import React from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { useTime } from "supercell-frontend-base/src/hooks/use-time";
import { Image } from "supercell-frontend-base/src/components/image";
import { LiveSlide } from "supercell-frontend-base/src/components/esport/types";
import styles from "./promotion-banner.modules.scss";

const formatTime = (timestamp: number): string => {
    const minutes = Math.floor((timestamp / 60) % 60);
    const hours = Math.floor((timestamp / (60 * 60)) % 24);
    const days = Math.floor(timestamp / (60 * 60 * 24));

    if (minutes === 0 && hours === 0 && days === 0) {
        return " 1m";
    }

    // \u00A0 is a non-breaking space
    return ` ${days <= 0 ? "" : `${days}d\u00A0`} ${
        hours <= 0 ? "0h" : `${hours}h`
    }\u00A0${days <= 0 ? `${minutes}m` : ""}`;
};

export const LiveEventPromotionBanner = (
    props: LiveSlide & { isLive: boolean },
) => {
    const currentTime = useTime();
    const startDate = new Date(props.livestreamStartTime ?? Date.now());
    const timestamp = startDate.getTime();
    const timeLeft = timestamp - currentTime.getTime();

    if (props.isLive) {
        return null;
    }

    return (
        <div
            className={classNames(styles.promo, {
                [styles.noName]: !props.eventPromotionName,
                [styles.noShield]: !props.eventPromotionLogo,
            })}
        >
            <div className={styles.name}>{props.eventPromotionName}</div>

            {props.eventPromotionLogo && (
                <div className={styles.shield}>
                    <Image sources={props.eventPromotionLogo} />
                </div>
            )}

            <div className={styles.liveIn}>
                <FormattedMessage id={"globalText.langLiveIn"} />

                {formatTime(Math.floor(timeLeft / 1000))}
            </div>

            <div className={styles.leftCorner}></div>

            <div className={styles.rightCorner}></div>
        </div>
    );
};
